import BankStatementAnalysisReport from "./BankStatementAnalysisReport";
import BusinessAnalysisReport from "./BusinessAnalysisReport";
import BusinessLicenseAnalyser from "./BusinessLicenseAnalyser";
import CreditAnalysisReport from "./CreditAnalysisReport";
import EmploymentPayslipAnalysisReport from "./EmploymentPayslipAnalysisReport";
import FinalAnalyzer from "./FinalAnalyzer";
import ITRAnalysisReport from "./ITRAnalysisReport";
import LoanStatementAnalysisReport from "./LoanStatementAnalysisReport";
import PropertyDocumentAnalyser from "./PropertyDocumentAnalyser";
import RentalAgreementReport from "./RentalAgreementReport";

const AnalyserReport = ({ analyzerType, analysisResult }) => {
  // Extract the analysis data from the backend response structure
  // Backend stores: perplexityResponse[0].analysis.rawText or results[0].analysis
  const analysisData =
    analysisResult?.results?.[0]?.analysis?.rawText ||
    analysisResult?.results?.[0]?.analysis ||
    analysisResult?.perplexityResponse?.[0]?.analysis?.rawText ||
    analysisResult?.perplexityResponse?.[0]?.analysis ||
    analysisResult?.openAIResponse ||
    analysisResult;

  // Create a standardized analysis result object
  const standardizedResult = {
    ...analysisResult,
    openAIResponse: analysisData,
    // Ensure backward compatibility
    analysisData: analysisData,
    // Handle multiple documents
    allResults: analysisResult?.results || analysisResult?.perplexityResponse || [],
  };

  // Map backend analyzer types to frontend components
  const analyzerTypeMap = {
    "credit-report": "universal-credit-report",
    "bank-statement": "universal-bank-statement",
    "loan-statement": "universal-loan-statement",
    payslip: "universal-payslip",
    itr: "universal-itr",
    "business-profile": "universal-business-profile",
    "property-document": "universal-property-document",
    "business-license": "universal-license-registration",
    "rental-agreement": "universal-legal-agreement",
    "evaluation-board": "universal-evaluation-board",
  };

  const mappedType = analyzerTypeMap[analyzerType] || analyzerType;

  if (mappedType === "universal-credit-report") {
    return <CreditAnalysisReport analysisResult={standardizedResult} />;
  } else if (mappedType === "universal-bank-statement") {
    return <BankStatementAnalysisReport analysisResult={standardizedResult} />;
  } else if (mappedType === "universal-loan-statement") {
    return <LoanStatementAnalysisReport analysisResult={standardizedResult} />;
  } else if (mappedType === "universal-payslip") {
    return (
      <EmploymentPayslipAnalysisReport analysisResult={standardizedResult} />
    );
  } else if (mappedType === "universal-itr") {
    return <ITRAnalysisReport analysisResult={standardizedResult} />;
  } else if (mappedType === "universal-business-profile") {
    return <BusinessAnalysisReport analysisResult={standardizedResult} />;
  } else if (mappedType === "universal-property-document") {
    return <PropertyDocumentAnalyser analysisResult={standardizedResult} />;
  } else if (mappedType === "universal-license-registration") {
    return <BusinessLicenseAnalyser analysisResult={standardizedResult} />;
  } else if (mappedType === "universal-legal-agreement") {
    return <RentalAgreementReport analysisResult={standardizedResult} />;
  } else if (mappedType === "universal-evaluation-board") {
    return <FinalAnalyzer analysisResult={standardizedResult} />;
  }

  // Fallback: display raw analysis data if no specific component matches
  return (
    <div className="bg-[#1f1f1f] p-4 rounded-lg">
      <h4 className="text-[#FFCA20] text-lg font-semibold mb-3">
        Analysis Results
      </h4>
      <div className="text-white">
        {analysisData ? (
          <pre className="whitespace-pre-wrap text-sm bg-[#131313] p-4 rounded border overflow-auto max-h-96">
            {typeof analysisData === "string"
              ? analysisData
              : JSON.stringify(analysisData, null, 2)}
          </pre>
        ) : (
          <p className="text-gray-400">No analysis data available</p>
        )}
      </div>
    </div>
  );
};

export default AnalyserReport;
